import * as React from 'react';
import { InvoiceEditor } from './client/components/invoiceEditor/InvoiceEditor';
import { DraftInterface } from './client/Interfaces/Draft/DraftInterface';
import { getCurrencySymbol } from './client/Other/Configs';
import config from './staticData/config';

export interface EditorPropsInterface {
  draft: DraftInterface;
  previewDraft: (draft) => {};
  actions: any;
  openPdfWindow: (draft) => void;
  downloadPDF: (draft, html?) => void;
  settings: any;
  language: string;
  locale: string;
}

export class Editor extends React.Component<EditorPropsInterface> {

  public render() {
    return (
      <div className="editor-root">
        <InvoiceEditor
          draft={this.props.draft}
          settings={this.props.settings}
          language={this.props.language}
          locale={this.props.locale}
          internal={{
            model: this.props.settings.models[0],
            currencySymbol: getCurrencySymbol(config, this.props.draft.fields.currency.value),
            defaultCurrency: 'EUR',
            language: this.props.language,
            lineColumns: ['description', 'quantity', 'unitPrice', 'vatPct', 'grossTotal'],
            schema: this.props.settings.schemas.invoice,
            template: null,
            visibleColumns: []
          }}
          previewDraft={this.props.previewDraft}
          openPdfWindow={this.props.openPdfWindow}
          downloadPDF={this.props.downloadPDF}
          {...this.props.actions}
        />
      </div>
    );
  }
}
